module.exports = __webpack_public_path__ + "img/main-image-bg.5fd81b95.svg";